import { SurveyApi, QuestionsApi, Configuration as SurveyConfig } from 'api/survey';
import { createApiConfig } from './adapters';

export const surveyAPI = new SurveyApi(createApiConfig(SurveyConfig));
export const questionsAPI = new QuestionsApi(createApiConfig(SurveyConfig));
